import { UserPermission } from '../../data/models/permission.model';

export const useHasPermission = (
  user: any,
  permission: UserPermission,
): boolean => {
  const hasIt = !!user?.access?.permissions.find((p: UserPermission) => {
    return (
      p.resource === permission.resource &&
      p.action === permission.action &&
      p.scope === permission.scope
    );
  });
  return hasIt;
};
